"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e=require("i18n-react"),t=require("easy-bem");function r(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var o=r(e),a=r(t);
/**
 * Translation hook that fetches translation values from the currently active language.
 * Translations should be component-scoped unless using the `t.general` method.
 * @name    useTranslate
 * @param   {String} component The name of the component
 */
const n=(e,t)=>{const r={element:e,modifiers:t};return"string"!=typeof t&&"number"!=typeof t||(0===t.toString().trim().length?r.modifiers={}:r.modifiers={[t]:!0}),"object"==typeof e&&(r.element="wrapper",r.modifiers=e),Object.values(r)};
/**
 * @typedef {Modifiers} {string}
 */exports.useClassName=e=>(t="wrapper",r={})=>({className:a.default(e)(...n(t,r))}),exports.useTranslate=e=>{if(!e)return()=>o.default.translate("dev.translationError")
/**
   * Returns a `ReactNode` with the selected translation value
   * @name t
   * @param {String} key Translation key to use
   * @param {Object} ctx Values to pass into the translation string
   */;const t=(t,r)=>o.default.translate([e,t].join("."),"object"==typeof r?r:{context:r})
/**
   * Returns a `ReactNode` with the selected translation value, general ignores the provided `component` name
   * and fetches translations from the `general` key instead.
   * @name t.general
   * @param {String} key Translation key to use
   * @param {Object} ctx Values to pass into the translation string
   */;return t.general=(e,t)=>o.default.translate(["general",e].join("."),"object"==typeof t?t:{context:t})
/**
   * Returns a `ReactNode` with the selected translation value, error ignores the provided `component` name
   * and fetches translations from the `error` key instead.
   * @name t.error
   * @param {String} key Translation key to use
   * @param {Object} ctx Values to pass into the translation string
   */,t.error=(e,t)=>o.default.translate(["error",e].join("."),"object"==typeof t?t:{context:t}),t};
//# sourceMappingURL=index.js.map
